var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToastIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 40,
    viewBox: "0 0 44 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.07955 16V40H0.125V16H8.07955ZM16.0341 40C14.9793 40 13.9676 39.5786 13.2217 38.8284C12.4759 38.0783 12.0568 37.0609 12.0568 36V16C12.0568 14.9 12.4943 13.9 13.2301 13.18L26.3153 0L28.4233 2.12C28.9602 2.66 29.2983 3.4 29.2983 4.22L29.2386 4.86L27.3494 14H39.8977C42.1051 14 43.875 15.8 43.875 18V22C43.875 22.52 43.7756 23 43.5966 23.46L37.5909 37.56C36.9943 39 35.5824 40 33.9318 40H16.0341ZM16.0341 36H33.9915L39.8977 22V18H22.4176L24.6648 7.36L16.0341 16.06V36Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastIcon);
export default __webpack_public_path__ + "static/media/toast-icon.2f0549a93c25bc3f3f295aae79ec5ca6.svg";
export { ForwardRef as ReactComponent };